export const isAnonymousEntity = (entityName: string) => {
  return entityName.startsWith('anony-mouse');
};
